export const common = {
    data() {
        return {
            ysyAdminUserNode_all: [],
            ysyMGetAdminUserOptions: [],
            ysyMAdminUserInfoOptions: [],
            ysyMAdminUserWorkInfoOptions: [],
            ysyMAboutNationOptions: [],
            ysyMAdminUserPersonalInfoOptions: [],
            ysyMGraduationInstitutionOptions: [],
            // ysyMGraduationInstitutionLocateOptions: [],
            ysyMAdminUserEducationInfoOptions: [],
            ysyMAdminUserBankCardInfoOptions: [],
            ysyMAdminUserContractInfoOptions: [],
            ysyMAdminUserContactInfoOptions: [],
            ysyMAdminUserFamilyInfoOptions: [],
            ysyMAdminPersonalMaterialsInfoOptions: []
        }
    },
    methods: {
        // 复制功能
        ysyCopy(data) {
            // 存储传递过来的数据
            let OrderNumber = data
            // 创建一个input 元素
            // createElement() 方法通过指定名称创建一个元素
            let newInput = document.createElement('input')
            // 讲存储的数据赋值给input的value值
            newInput.value = OrderNumber
            // appendChild() 方法向节点添加最后一个子节点。
            document.body.appendChild(newInput)
            // 选中input元素中的文本
            // select() 方法用于选择该元素中的文本。
            newInput.select()
            // 执行浏览器复制命令
            //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
            document.execCommand('Copy')
            // 清空输入框
            newInput.remove()
            // 下面是element的弹窗 不需要的自行删除就好
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        ysyCopySome(data) {
            this.ysyCopy(data)
        },
        ysyGetAdminUserNode_all() {
            this.$axios.get('api/phone_get_adminuser_node_all').then(({ data }) => {
                if (data.code === 200) {
                    this.ysyAdminUserNode_all = data.node
                }
            }).catch()
        },
        ysyMGetAdminUser() {
            this.$axios.get('api/expmanage/getreceiver').then(({ data }) => {
                if (data.code === 1) {
                    this.ysyMGetAdminUserOptions = data.data
                }
            }).catch()
        },
        // 人员信息-基本信息
        ysyMGetAdminUserInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-工作信息
        ysyMGetAdminUserWorkInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_work_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserWorkInfoOptions = data.data
                }
            }).catch()
        },
        // 获取民族
        ysyMGetAboutNation() {
            this.$axios.get('api/api3_get_about_nation').then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAboutNationOptions = data.data
                }
            }).catch()
        },
        // 人员信息-个人信息
        ysyMGetAdminUserPersonalInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_personal_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserPersonalInfoOptions = data.data
                }
            }).catch()
        },
        // 获取高校信息-远程搜索
        ysyMGetGraduationInstitution(keyword) {
            this.$axios.get('api/api3_get_graduation_institution', {
                params: {
                    keyword
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMGraduationInstitutionOptions = data.data
                }
            }).catch()
        },
        // // 获取高校信息-定位
        // ysyMGetGraduationInstitutionLocate(id) {
        //     this.$axios.get('api/api3_get_graduation_institution_locate', {
        //         params: {
        //             id
        //         }
        //     }).then(({ data }) => {
        //         if (data.code === 200) {
        //             this.ysyMGraduationInstitutionLocateOptions = data.data
        //         }
        //     }).catch()
        // },
        // 人员信息-学历信息
        ysyMGetAdminUserEducationInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_education_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserEducationInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-银行卡信息
        ysyMGetAdminUserWorkInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_bank_card_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserBankCardInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-合同信息
        ysyMGetAdminUserContractInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_contract_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserContractInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-紧急联系人信息
        ysyMGetAdminUserContactInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_contact_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserContactInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-家庭信息
        ysyMGetAdminUserFamilyInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_family_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminUserFamilyInfoOptions = data.data
                }
            }).catch()
        },
        // 人员信息-个人材料信息
        ysyMGetAdminUserPersonalMaterialsInfo(admin_user_id) {
            this.$axios.get('api/api3_get_admin_user_personal_materials_info', {
                params: {
                    admin_user_id
                }
            }).then(({ data }) => {
                if (data.code === 200) {
                    this.ysyMAdminPersonalMaterialsInfoOptions = data.data
                }
            }).catch()
        },
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/mixins/common.js
// module id = null
// module chunks = 